import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { getWidgets } from "../../../action/masters/widgetActionCreator";
import { baseURL } from "../../../constants/commonConstants";
import { IWidgets } from "../../../models/master/widgets";
import { setWidgets } from "../../../store/slices/master/widgetSlice";
import { IResourceWidgets } from "../../../models/common/IResources";
import { getDepartmentResources } from "../../../action/masters/departmentResourceActionCreator";
import { setDepartmentResources } from "../../../store/slices/master/departmentResource";
import { pageBlockId } from "../../../constants/pageBlocks";

const ResourceWidgets = (props: IResourceWidgets) => {
  const {
    getAllWidgets,
    widgets,
    role,
    departmentResources,
    getDepartmentResources,
  } = props;
  const [selectedResourceId, setSelectedResourceId] = useState<number | null>(
    null
  );
  const dispatch = useDispatch();

  useEffect(() => {
    switch (role) {
      case "Staff":
        getDepartmentResources();
        break;
      case "Faculty":
        getAllWidgets(pageBlockId.facultyResources, undefined);
        break;
      case "Student":
        getAllWidgets(pageBlockId.studentResources, undefined);
        break;
      default:
        break;
    }
  }, [role]);

  useEffect(() => {
    return () => {
      dispatch(setWidgets([]));
      dispatch(setDepartmentResources([]));
    };
  }, []);

  const dataToRender = role === "Staff" ? departmentResources : widgets;

  useEffect(() => {
    if (dataToRender && dataToRender.length > 0) {
      setSelectedResourceId(dataToRender[0].id);
    }
  }, [dataToRender]);

  const handleClickId = (id: number | null) => {
    setSelectedResourceId(id ?? 0);
  };

  return (
    <>
      <div className="card-wrap" id="studentresource">
        <div className="title">
          <h2>{role} Resources</h2>
        </div>
        <div className="row">
          <div className="col-lg-4">
            <ul className="course-list resouce-list">
              {dataToRender
                ?.filter((widget: IWidgets) => widget.displayOrNot)
                .map((widget: IWidgets, index: number) => (
                  <li
                    id="apps1"
                    className={`${
                      selectedResourceId === widget.id ? "active" : ""
                    }`}
                    onClick={() => handleClickId(widget.id)}
                  >
                    <div className="img">
                      <img src={baseURL + widget.image} alt="" />
                    </div>
                    <div className="dtls">
                      <img
                        className="r-none"
                        src={baseURL + widget.image}
                        alt=""
                      />
                      <h6>{widget.name}</h6>
                      <p>{widget.description}</p>
                    </div>
                  </li>
                ))}
            </ul>
          </div>

          <div className="col-lg-8 adaptheight">
            <div className="row py-3 resourcedtls resource1 show">
              {dataToRender &&
                (() => {
                  const selectedWidget = dataToRender.find(
                    (widget: IWidgets) =>
                      widget.displayOrNot && widget.id === selectedResourceId
                  );
                  return selectedWidget ? (
                    <>
                      <div className="col-lg-3">
                        <img
                          src={baseURL + selectedWidget.image}
                          alt=""
                          className="w-100"
                          style={{ borderRadius: "16px" }}
                        />
                      </div>
                      <div className="col-lg-9">
                        <img
                          src={baseURL + selectedWidget.image}
                          alt=""
                          className="r-none"
                          style={{ borderRadius: "16px" }}
                        />
                        <h2 className="mb-2">{selectedWidget.name}</h2>
                        <p>{selectedWidget.description}</p>
                        <a
                          href={selectedWidget.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <button className="btn btn-primary mt-3">
                            View Details
                          </button>
                        </a>
                      </div>
                    </>
                  ) : null;
                })()}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getAllWidgets: (pageBlockId: number, noOfItems: number) =>
    getWidgets(undefined, pageBlockId, noOfItems),
  getDepartmentResources: () => getDepartmentResources(),
};

function mapStateToProps(state: any) {
  return {
    widgets: state.widget.widgets,
    departmentResources: state.departmentResource.departmentResources,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResourceWidgets);
